export class BrowserCompatibility {
  public static isCompatible(): boolean {
    let compatibility = true;

    const lastMsieVersionSupported = 9;
    const lastChromeVersionSupported = 28;
    const lastSafariVersionSupported = 6;
    const lastOperaVersionSupported = 15;
    const lastMozillaVersionSupported = 23;

    const nAgt = window.navigator.userAgent;
    let browserName = window.navigator.appName;
    let fullVersion = '' + parseFloat(window.navigator.appVersion);
    let majorVersion = parseInt(window.navigator.appVersion, 10);
    let nameOffset, verOffset, ix;

    // In Opera 15+, the true version is after "OPR/"
    if ((verOffset = nAgt.indexOf('OPR/')) !== -1) {
      browserName = 'opera';
      fullVersion = nAgt.substring(verOffset + 4);
    }
    // In older Opera, the true version is after "Opera" or after "Version"
    else if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
      browserName = 'opera';
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf('Version')) !== -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
      browserName = 'ie';
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
      browserName = 'chrome';
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
      browserName = 'safari';
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf('Version')) !== -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
      browserName = 'firefox';
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
      (verOffset = nAgt.lastIndexOf('/'))) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() === browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) !== -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(' ')) !== -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = '' + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }

    switch (browserName) {
      case 'opera':
        if (majorVersion < lastOperaVersionSupported) {
          compatibility = false;
        }
        break;
      case 'ie':
        if (majorVersion < lastMsieVersionSupported) {
          compatibility = false;
        }
        break;
      case 'chrome':
        if (majorVersion < lastChromeVersionSupported) {
          compatibility = false;
        }
        break;
      case 'safari':
        if (majorVersion < lastSafariVersionSupported) {
          compatibility = false;
        }
        break;
      case 'firefox':
        if (majorVersion < lastMozillaVersionSupported) {
          compatibility = false;
        }
        break;

    }

    return compatibility;
  }
}

